import { render, staticRenderFns } from "./addSituationSolution.vue?vue&type=template&id=639a385f&scoped=true"
import script from "./addSituationSolution.vue?vue&type=script&lang=js"
export * from "./addSituationSolution.vue?vue&type=script&lang=js"
import style0 from "./addSituationSolution.vue?vue&type=style&index=0&id=639a385f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639a385f",
  null
  
)

export default component.exports